import { post } from "../../utils/Backend";
import { useLongfansMock } from "../../global/GlobalMock";
import {
  mockListInfluencerCards,
  mockListMySubscribedInfluencerCards,
} from "./LobbyMock";
import type { InfluencerCard } from "./LobbyType";

function toInt01(v: unknown): 0 | 1 {
  if (v === true) return 1;
  if (v === 1) return 1;
  if (typeof v === "number" && v === 1) return 1;
  if (typeof v === "string") {
    const t = v.trim();
    if (t === "1" || t === "true") return 1;
  }
  return 0;
}

const normalizeCard = (c: InfluencerCard): InfluencerCard => {
  // 与后端/网关可能输出的蛇形、以及 camelCase 两种键名都兼容，避免 favorStatus 读不到时「我的关注」被滤空
  const row = c as unknown as Record<string, unknown>;
  const favor = row.favorStatus ?? row.favor_status;
  const sub = row.subStatus ?? row.sub_status;
  const m =
    (row.membershipTag ?? row.membership_tag) as string | null | undefined;
  const u = typeof m === "string" ? m.toUpperCase() : m;
  const membershipTag: "ACTIVE" | "EXPIRED" | null =
    u === "ACTIVE" || u === "EXPIRED" ? (u as "ACTIVE" | "EXPIRED") : null;
  return {
    ...c,
    favorStatus: toInt01(favor),
    subStatus: toInt01(sub),
    membershipTag,
  };
};

/** 开发环境 React.StrictMode 会双挂 effect，合并为同一次 HTTP，避免 myFollowSpaceCards 连打两次 */
let myFollowSpaceCardsInFlight: Promise<InfluencerCard[]> | null = null;

/** 仅当前用户已关注或已建订阅关系的空间，非全站列表 */
const listMySubscribedInfluencerCards = async (): Promise<InfluencerCard[]> => {
  if (useLongfansMock) {
    return mockListMySubscribedInfluencerCards();
  }
  if (myFollowSpaceCardsInFlight) {
    return myFollowSpaceCardsInFlight;
  }
  myFollowSpaceCardsInFlight = (async () => {
    try {
      const res = await post<Record<string, never>, InfluencerCard[]>(
        "/lark/app/user/myFollowSpaceCards",
        {}
      );
      if (typeof res === "string") {
        throw new Error(res);
      }
      if (!Array.isArray(res)) {
        throw new Error("列表数据异常");
      }
      return res.map(normalizeCard);
    } finally {
      myFollowSpaceCardsInFlight = null;
    }
  })();
  return myFollowSpaceCardsInFlight;
};

const listInfluencerCards = async (
  arenaSpaceId: string
): Promise<InfluencerCard[]> => {
  if (useLongfansMock) {
    return mockListInfluencerCards(arenaSpaceId);
  }
  const res = await post<{ arenaSpaceId: string }, InfluencerCard[]>(
    "/api/lobby/influencerCards",
    { arenaSpaceId }
  );
  if (typeof res === "string") {
    return [];
  }
  return res.map(normalizeCard);
};

export const LobbyApi = {
  listMySubscribedInfluencerCards,
  listInfluencerCards,
};
